import {
  PROMO_CODE_FAILED,
  PROMO_CODE_SUCCESS,
  PROMO_CODE_INVALID_REQUEST,
  PROMO_CODE_NOT_FOUND,
  LOADING_PROMO_CODE,
  RESET_PROMO_CODE,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  promocodes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PROMO_CODE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case PROMO_CODE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };

    case PROMO_CODE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case PROMO_CODE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        promocodes: action.payload,
      };
    }

    case PROMO_CODE_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_PROMO_CODE:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
